module.exports = __webpack_public_path__ + "img/support_equi_mb_3.66c1eef9.jpg";